import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Topbar from './Topbar'

const ReceptionistLayout = () => (
  <>
  <Topbar />
  <div className="container  w-100 mw-100" style={{ display: 'flex' }}>
    <Navbar />
    <div className=" w-100 mw-100 ">
      <Outlet />
    </div>
  </div>
  </>
);

export default ReceptionistLayout;